import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { LoginFormComponent } from './widgets/login-form/login-form.component';
import { SignupFormComponent } from './widgets/signup-form/signup-form.component';
import { createCustomElement } from '@angular/elements';
import { Injector } from '@angular/core';
import { ForgotPasswordFormComponent } from './widgets/forgot-password-form/forgot-password-form.component';
import { IconService } from './services/icon.service';
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [LoginFormComponent, SignupFormComponent, ForgotPasswordFormComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  // template: '<ng-content></ng-content>'
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  ngOnInit() {
    // Register the web components
    if (!customElements.get('login-widget')) {
      const loginElement = createCustomElement(LoginFormComponent, { injector: this.injector });
      customElements.define('login-widget', loginElement);
    }
    
    if (!customElements.get('signup-widget')) {
      const signupElement = createCustomElement(SignupFormComponent, { injector: this.injector });
      customElements.define('signup-widget', signupElement);
    }

    if (!customElements.get('forgot-password-widget')) {
      const forgotPasswordElement = createCustomElement(ForgotPasswordFormComponent, { injector: this.injector });
      customElements.define('forgot-password-widget', forgotPasswordElement);
    }
  }

  constructor(private injector: Injector, private iconService: IconService) {
    // IconService is injected to ensure icons are registered at app startup
  }
}
